// Web stub for react-native-send-intent
export default {
  openApp: async () => false,
  openChromeIntent: () => {},
  sendText: () => {},
  sendPhoneCall: () => {},
  sendSms: () => {},
  openCalendar: () => {},
  openMaps: () => {},
  openMapsWithRoute: () => {},
  isAppInstalled: async () => false,
  installRemoteApp: () => {},
  gotoHomeScreen: () => {},
}
